import type { PresenceState, PresenceStateUser } from '../editor/editorSlice';

const getUsersFromPresence = (
  presence: PresenceState[],
): {
  user: PresenceStateUser;
  status: 'editing' | 'reading' | 'inactive';
}[] =>
  presence.map(({ user, metas }) => {
    const activeMetas = metas.filter((meta) => meta.active);

    const isInactive = !activeMetas.length;
    if (isInactive) {
      return { user, status: 'inactive' };
    }

    const isEditing = activeMetas.some((meta) => meta.edit);
    return { user, status: isEditing ? 'editing' : 'reading' };
  });

export default getUsersFromPresence;
